import React, { useContext } from 'react';
import AppEmojiIcons from '../../icons/emojiIcons';
import AppIcons from '../../icons';
import DateComponent from '../DateComponent';
import style from './styles.module.css';
import { AdminContext } from '../../context/AdminContext';

export default function MessageDateSeen({ item, showSeen = true }) {
  const {content} = useContext(AdminContext)
  return (
    <div
      className={`flex flex-row justify-between items-center 
 w-full ${
   (item?.file?.fileExtension?.type == 'image' ||
     item?.file?.fileExtension?.type == 'video') &&
   style.extraMargin
 }`}
    >
      {/* <img
                alt="cancel"
                src={'/imgs/login/reply.svg'}
                width={15}
                height={15}
                containerclassName={`flex flex-row justify-center items-center h-auto  ${
                  themeColor != 'white' && 'makeWhite'
                }`}
              /> */}
      <div
        className={`flex flex-row-reverse justify-between items-center w-full ${
          (item?.file?.fileExtension?.type == 'image' ||
            item?.file?.fileExtension?.type == 'video') &&
          'imageMessageInfo'
        }`}
      >
        <div className={`flex flex-row justify-start items-center w-auto h-auto`}>
        {/* {item?.chatPin?.length != 0 && item?.chatPin != undefined &&

<AppEmojiIcons.StarFullIcon  width={"18px"} height={'18px'} fill={`#004ab6`}  className={`noFilterSvg seenIcon`}/>

} */}
        {showSeen == true && (
          <>
            {item?.flagId != 1 ? (
              <AppIcons.unSeenIcon
                width={20}
                height={20}
                className={`noFilterSvg`}
              />
            ) : (
              <AppIcons.seenIcon
                width={20}
                height={20}
                className={`noFilterSvg seenIcon`}
              />
            )}
          </>
        )}

</div>
        <div
          className={`date flex flex-row justify-start items-center h-auto w-auto my-[5px] `}
        >
            {item?.roomUserFromId?.length !=0 && item?.roomUserFromId && <p style={{margin:'0 5px'}}>({content?.forwarded})</p>}
          <DateComponent
            item={item}
            createdAt={item?.createdAt}
            className={`preserveWhiteThemeColor`}
          />
        </div>
      </div>
      {/* <div></div> */}
      {/* <AppIcons.replyIcon
                            width={20}
                            height={20}
                            onClick={() => replyFunction(message)}
                            fill="#4A5568"
                          /> */}
    </div>
  );
}
